<template>
    <div ref="introBgContainer" id="chuangIntroduction">
        <div class="introduction-sub-container">
            <div :class="{'introduction-placeholder': true}">
                <div class="introduction-sub-image-container">
                    <img class="introduction-sub-bg" src="../assets/images/sub-heading.png" alt="">
                </div>
                <h5 v-html="introTitleLanguages[selectedLanguage]"></h5>
                <p  v-html="languageToDisplay[selectedLanguage]"></p>
            </div>
            <div id="manageLink"></div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                introGotFocus: false,
                isAnimateChangeLanguageOn: false,
                languageToDisplay: [],
                res:0,
                introTitleLanguages: 
                [
                    'Hello, we design mobile  &amp <br> web interfaces that are simple to use.', 
                    'Hello, we design mobile  &amp <br> web interfaces that are simple to use.',
                    'Hello, we design mobile  &amp <br> web interfaces that are simple to use.'
                ],
                descriptionLanguages: 
                [
                    [
                    '創樂科技有限公司剛於2017年6月成立，為香港在台灣投資的遊戲軟體公司。我們擁有良好的研究開發及技術支援，目前以研製手遊為主，且在台灣、香港、中國、菲律賓、馬來西亞等地已有公司。正陸續朝向日本、韓國、泰國等東南亞國家市場持續拓展，並規畫著未來進軍歐美市場。期待能打造原創遊戲品牌，在台灣與海外市場佔有一席之地。',
                    '创乐科技有限公司刚于2017年6月成立，为香港在台湾投资的游戏软件公司。我们拥有良好的研究开发及技术支援，目前以研制手游为主，且在台湾、香港、中国、菲律宾、马来西亚等地已有公司。正陆续朝向日本、韩国、泰国等东南亚国家市场持续拓展，并规画着未来进军欧美市场。期待能打造原创游戏品牌，在台湾与海外市场占有一席之地。',
                    'Founded in June 2017, Chuangle Co. Ltd., is a Hong Kong funded gaming software company in Taiwan.We have a promising gaming software technology development and supporting  team. As of now, we mainly develop online games, and have established companies in several places such as Taiwan, Hong Kong, China, Philippines, Malaysia and so on.We are expanding our market in Japan, South Korea, Thailand and other ASEAN countries. One of our goals in to have a market in Europe and America in the near future.We are looking forward to develop original and unique game brand, and make a name in Taiwan locally and abroad.'
                    ],
                    [
                    '創樂科技有限公司剛於2017年6月成立， 為香港在台灣投資的遊戲軟體公司。<br>我們擁有良好的研究開發及技術支援， 目前以研製手遊為主，<br>且在台灣、香港、中國、菲律賓、 馬來西亞等地已有公司。 <br>正陸續朝向日本、韓國、泰國等東南亞國家市場持續拓展，並規畫著未來進軍歐美市場。 <br>期待能打造原創遊戲品牌，在台灣與海外市場佔有一席之地。',
                    '创乐科技有限公司刚于2017年6月成立， 为香港在台湾投资的游戏软件公司。<br>我们拥有良好的研究开发及技术支援， 目前以研制手游为主，<br>且在台湾、香港、中国、菲律宾、 马来西亚等地已有公司。 <br>正陆续朝向日本、韩国、泰国等东南亚国家市场持续拓展，并规画着未来进军欧美市场。 <br>期待能打造原创游戏品牌，在台湾与海外市场占有一席之地。',
                    'Founded in June 2017, Chuangle Co. Ltd., is a Hong Kong funded gaming software company in Taiwan.<br>We have a promising gaming software technology development and supporting team. <br> As of now, we mainly develop online games, <br> and have established companies in several places such as Taiwan, Hong Kong, China, Philippines, Malaysia and so on. <br>We are expanding our market in Japan, South Korea, Thailand and other ASEAN countries.<br> One of our goals in to have a market in Europe and America in the near future. <br>We are looking forward to develop original and unique game brand, and make a name in Taiwan locally and abroad.'
                    ],

                ],
                // descriptionLanguages: 
                // [
                //     [
                //     '創樂科技有限公司剛於今年成立， 為香港<br>在台灣投資的遊戲軟體公司。我們擁有良好<br>的戲軟體技術研究開發及技術支援， 目前<br>已研製手遊為主，且在台灣、香港、中國、<br>菲律賓、 馬來西亞等地已有公司。正陸續<br>朝向日本、韓國、泰國等東南亞國家市場持<br>續拓建，我們也規畫著未來進軍歐美市場。 <br> 期待未來能打造原創遊戲品牌，在台灣與海<br>外市場佔有一席之地。',
                //     '创乐科技有限公司刚于今年成立， 为香港<br>在台湾投资的游戏软件公司。我们拥有良好<br>的戏软件技术研究开发及技术支援， 目前<br>已研制手游为主，且在台湾、香港、中国、<br>菲律宾、 马来西亚等地已有公司。正陆续<br>朝向日本、韩国、泰国等东南亚国家市场持<br>续拓建，我们也规画着未来进军欧美市场。<br> 期待未来能打造原创游戏品牌，在台湾与海<br>外市场占有一席之地。',
                //     'Founded in 2017, Chuangle Co. Ltd., is a<br> Hong Kong funded gaming software <br>company in Taiwan. We have a promising<br> gaming software technology development and supporting  team.<br> As of now, we mainly develop online<br> games, and have established companies<br> in several places such as Taiwan, Hong<br> Kong, China, Philippines, Malaysia and <br>so on.We are expanding our market in <br>Japan, South Korea, Thailand and other<br> ASEAN countries. One of our goals is to <br>have a market in Europe and America in <br>the near future.We are looking forward <br>to develop original and unique game<br> brand, and make a name in Taiwan locally and abroad.'
                //     ],
                //     [
                //     '創樂科技有限公司剛於今年成立， 為香港在台灣投資的遊戲軟體公司。<br> 我們擁有良好的戲軟體技術研究開發及技術支援， 目前已研製手遊為主，<br> 且在台灣、香港、中國、菲律賓、 馬來西亞等地已有公司。 <br> 正陸續朝向日本、韓國、泰國等東南亞國家市場持續拓建，我們也規畫著未來進軍歐美市場。 <br> 期待未來能打造原創遊戲品牌，在台灣與海外市場佔有一席之地。',
                //     '创乐科技有限公司刚于今年成立， 为香港在台湾投资的游戏软件公司。<br>我们拥有良好的戏软件技术研究开发及技术支援， 目前已研制手游为主，<br>且在台湾、香港、中国、菲律宾、 马来西亚等地已有公司。<br> 正陆续朝向日本、韩国、泰国等东南亚国家市场持续拓建，我们也规画着未来进军欧美市场。<br> 期待未来能打造原创游戏品牌，在台湾与海外市场占有一席之地。',
                //     'Founded in 2017, Chuangle Co. Ltd., is a Hong Kong funded gaming software company in Taiwan.<br>We have a promising gaming software technology development and supporting  team.<br> As of now, we mainly develop online games,<br> and have established companies in several places such as Taiwan, Hong Kong, China, Philippines, Malaysia and so on.<br>We are expanding our market in Japan, South Korea, Thailand and other ASEAN countries. <br>One of our goals in to have a market in Europe and America in the near future.<br>We are looking forward to develop original and unique game brand, <br>and make a name in Taiwan locally and abroad.'
                //     ],

                // ],
                clientWidth: 0,
                selectedLanguage: 0
            }
        },
        methods: {
            startChangeLangAnimation(){
                let _this = this;
                this.isAnimateChangeLanguageOn = true;
                _this.selectedLanguage = parseInt(e);
            },
            changeIntroBackground(){
                if(this.clientWidth <= 900 &&  this.selectedLanguage == 2) {
                    this.$refs.introBgContainer.style.backgroundImage = "url("+ require('../assets/images/intro-bg-eng.png') + ")";
                } else if (this.clientWidth <= 900 &&  this.selectedLanguage != 2) {
                    this.$refs.introBgContainer.style.backgroundImage = "url("+ require('../assets/images/intro-bg-ch.png') + ")";
                } else if (this.clientWidth > 900) {
                    this.$refs.introBgContainer.style.backgroundImage = "url("+ require('../assets/images/introduction-bg-pc.png') + ")";
                }
            }
        },
        mounted: function() {
            let _this = this;
            this.$root.$on('languageChange', function(e){
                _this.selectedLanguage = parseInt(e);
                _this.changeIntroBackground();
            })

            window.addEventListener('resize', function(e){
                let h = document.getElementById('chuangIntroduction').offsetHeight;
                _this.clientWidth = document.getElementById('chuangIntroduction').clientWidth;
                _this.$root.$emit('updateIntroSize', h);
                _this.changeIntroBackground();
                if (_this.clientWidth <= 990) {
                    _this.languageToDisplay = _this.descriptionLanguages[0]
                } else {
                    _this.languageToDisplay = _this.descriptionLanguages[1]
                }
            });
            window.addEventListener('load', function(e){
                let h = document.getElementById('chuangIntroduction').offsetHeight;
                _this.clientWidth = document.getElementById('chuangIntroduction').clientWidth;
                _this.$root.$emit('updateIntroSize', h)
                _this.changeIntroBackground();
                if (_this.clientWidth <= 990) {
                    _this.languageToDisplay = _this.descriptionLanguages[0]
                } else {
                    _this.languageToDisplay = _this.descriptionLanguages[1]
                }
                _this.res = window.screen.width;
            });
            
        },
    }
</script>

<style lang="less" scoped>
@import url('../assets/css/base.less');

    .overwrite-row {
        margin-bottom: none!important;
    }
    #chuangIntroduction {
        position: relative;
        background: url('../assets/images/introduction-bg-pc.png') no-repeat center;
        background-size: cover;
        min-width: @min-width;
        .introduction-sub-container {
            top: 0;
            left: 0;
            width: 100%;
            padding-top: 11rem;
            padding-bottom: 7rem;
            padding-left: 0.7rem;
            padding-right: 0.7rem;
            @media @768 {
                padding-top: 6rem;
                padding-bottom: 3rem;
                padding-left: 0.7rem;
                padding-right: 0.7rem;
            }
            @media @479 {
                padding-top: 8rem;
                padding-bottom: 3rem;
                padding-left: 0.7rem;
                padding-right: 0.7rem;
            }
            @media @320 {
                padding-top: 7rem;
                padding-bottom: 3rem;
                padding-left: 0.7rem;
                padding-right: 0.7rem;
            }
            .introduction-placeholder {
                margin: 0 auto;
                color: #e5e5e5;
                .introduction-sub-image-container {
                    margin: 0 auto;
                    width: 20rem;
                    @media @768 {
                        width:18rem;
                    }
                    @media @479 {
                        width:15rem;
                    }
                    .introduction-sub-bg {
                        width: 100%;    
                    }
                }
                h5 {
                    font-size: @cons-main-text-size-1600;    
                    margin: 0 auto;
                    margin-top: 1rem;
                    margin-bottom: 1rem;
                    text-align: center;  
                    @media @1920 {
                        font-size: @cons-main-text-size-1600;
                        width: 30rem;
                    }
                    @media @1600 {
                        font-size: @cons-main-text-size-1600;
                        width: 30rem;
                    }
                    @media @1400 {
                        font-size: @cons-main-text-size-1600;
                        width: 30rem;
                    }
                    @media @1200 {
                        font-size: @cons-main-text-size-1600;
                        width: 30rem;
                    }
                    @media @990 {
                        font-size: @cons-main-text-size-1600;
                        width: 30rem;
                    }
                    @media @768 {
                        font-size: @cons-main-text-size-1600;
                        width: 25rem;

                    }
                    @media @479 {
                        font-size: @cons-main-text-size-1600 - 0.3;
                        width: 80vw;

                    }
                    @media @360 {
                        font-size: @cons-main-text-size-1600 - 0.4;
                        width: 73vw;
                    }
                    @media @320 {
                        font-size: @cons-main-text-size-1600 - 0.4;
                        width: 83vw;

                    }
                }
                p { 
                    font-size: @cons-description-text-size-1920;
                    margin-top: 1rem;
                    line-height: 2.6rem;
                    text-align: center;
                    margin: 0 auto;
                    @media @1920 {
                        font-size: @cons-description-text-size-1920;
                        margin-top: 0.8em;
                        line-height: 2.6rem;
                        text-align: center;
                    }
                    @media @1600 {
                        font-size: @cons-description-text-size-1920;
                        margin-top: 0.8em;
                        line-height: 2.6rem;
                        text-align: center;
                    }
                    @media @1400 {
                        font-size: @cons-description-text-size-1920;
                        margin-top: 0.8em;
                        line-height: 2.6rem;
                        text-align: center;
                    }
                    @media @1200 {
                        font-size: @cons-description-text-size-1920;
                        margin-top: 0.7em;
                        line-height: 2.6rem;
                        text-align: center;
                    }
                    @media @990 {
                        font-size: @cons-description-text-size-1920;
                        margin-top: 0.5rem;
                        line-height: 1.9rem;
                        width: 25rem;
                        text-align: left;
                    }
                    @media @768 {
                        font-size: @cons-description-text-size-1920;
                        margin-top: 0.5rem;
                        line-height: 1.9rem;
                        width: 37rem;
                        // width: 20vw;
                        text-align: left;
                    }
                    @media @479 {
                        font-size: @cons-description-text-size-1920 - 0.1;
                        margin-top: 0.5rem;
                        line-height: 1.9rem;
                        width: 22rem;
                        text-align: left;
                    }
                    @media @360 {
                        font-size: @cons-description-text-size-1920 - 0.3;
                        margin-top: 0.5rem;
                        line-height: 1.9rem;
                        width: 19rem;
                        text-align: left;
                    }
                    @media @320 {
                        font-size: @cons-description-text-size-1920;
                        margin-top: 0.5rem;
                        line-height: 1.9rem;
                        width: 18rem;
                        text-align: left;
                    }
                }
            }
        }
        .introduction-main-bg {
            width: 100%;
            height: 100%;

        }
    }
    #manageLink {
        height: 5.7rem;
        position: absolute;
        bottom: 0;
        @media @1920 {
            height: 5.7rem;
        }
        @media @1600 {
            height: 5.7rem;
        }
        @media @1400 {
            height: 5.7rem;
        }
        @media @1200 {
            height: 5.8rem;
        }
        @media @990 {
            height: 5.5rem;
        }
        @media @768 {
            height: 4.3rem;
        }
        @media @479 {
            height: 4.3rem;
        }
        @media @360 {
            height: 4.3rem;
        }
        @media @320 {
            height: 4.3rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/ChuangIntroduction.vue